<!-- <dynamic-form
  [group]="group"
  [serviceName]="'DemandFinanceRequestService'"
  [loading]="loading"
  [visuals]="visuals"
  [genericVisuals]="genericVisuals"
  [formErrors]="formErrors"
  #form="dynamicForm"
  (submit)="submit($event)"
  (modalOutput)="handleModalOutput($event)"
  (formChanges)="handleFormChanges($event)">
</dynamic-form> -->

<base-table-layout
  [records]="grid"
  [footer]="footer"
  [gridActions]="gridActions"
  [hasRowCheckbox]="hasRowCheckbox"
  [settings]="columnSetting"
  [searched]="searched"
  [loading]="loading"
  [downloading]="downloading"
  [checkboxLoading]="checkboxLoading"
  [count]="count"
  [visuals]="visuals"
  [genericVisuals]="genericVisuals"
  (outputMethodHandler)="outputMethodHandler($event)"
  [sortNum]="sortNum"
  [sortDir]="sortDir"
  (changeSortHandler)="changeSort($event)"
  [pageSize]="pageSize"
  [pageNum]="pageNum"
  [pageMax]="pageMax"
  (changePageHandler)="changePage($event)"
  (changePageSizeHandler)="changePageSize($event)"
>
</base-table-layout>

<div
  bsModal
  #confirmModal="bs-modal"
  [config]="{backdrop: 'static'}"
  class="modal fade"
  tabindex="-1"
  role="dialog"
  aria-labelledby="myLargeModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title pull-left">{{visuals.title}}</h4>
        <button
          type="button"
          class="close pull-right"
          aria-label="Close"
          (click)="confirmModal.hide()"
        >
          <span aria-hidden="true"><i class="fa fa-close"></i></span>
        </button>
      </div>
      <div class="modal-body">
        <div class="card card-accent-primary shadowed">
          <div class="card-header">
            <strong>{{genericVisuals.confirmation}}</strong>
            <a
              href="javascript:void(0);"
              role="button"
              class="pull-right"
              (click)="isCollapsed = !isCollapsed"
              ><i *ngIf="isCollapsed" class="fa fa-plus-circle"></i
              ><i *ngIf="!isCollapsed" class="fa fa-minus-circle"></i
            ></a>
          </div>
          <div class="card-block">
            <div *ngIf="submiting" class="dataLoader alert"></div>

            <div *ngIf="!submiting">
              <div class="card-block text-center alert alert-info" [collapse]="isCollapsed">
                <strong>{{visuals.confirmationMsg}}</strong>
                <p class="m-0">{{visuals.massApprove}}</p>
              </div>
            </div>
          </div>
          <div class="card-footer" style="text-align: center;">
            <a
              href="javascript:void(0);"
              class="btn btn-outline-default"
              (click)="confirmModal.hide()"
              ><i class="fa fa-close"></i>{{genericVisuals.return}}</a
            >
            <button
              class="btn btn-success btn-shadowed"
              name="repApproveDemandsSubmitButton"
              (click)="confirmApprove()"
              [disabled]="loading || submiting"
            >
              <i class="fa fa-check"></i>{{genericVisuals.submit}}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div
  bsModal
  #rejectModal="bs-modal"
  [config]="{backdrop: 'static'}"
  class="modal fade"
  tabindex="-1"
  role="dialog"
  aria-labelledby="myLargeModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title pull-left">{{visuals.title}}</h4>
        <button
          type="button"
          class="close pull-right"
          aria-label="Close"
          (click)="confirmModal.hide()"
        >
          <span aria-hidden="true"><i class="fa fa-close"></i></span>
        </button>
      </div>
      <div class="modal-body">
        <div class="card card-accent-primary shadowed">
          <div class="card-header">
            <strong>{{genericVisuals.confirmation}}</strong>
            <a
              href="javascript:void(0);"
              role="button"
              class="pull-right"
              (click)="isCollapsed = !isCollapsed"
              ><i *ngIf="isCollapsed" class="fa fa-plus-circle"></i
              ><i *ngIf="!isCollapsed" class="fa fa-minus-circle"></i
            ></a>
          </div>
          <div class="card-block">
            <div *ngIf="submiting" class="dataLoader alert"></div>

            <div *ngIf="!submiting">
              <div class="card-block text-center alert alert-info" [collapse]="isCollapsed">
                <strong>{{visuals.confirmationMsg}}</strong>
                <p class="m-0">{{visuals.massReject}}</p>
              </div>
            </div>
          </div>
          <div class="card-footer" style="text-align: center;">
            <a
              href="javascript:void(0);"
              class="btn btn-outline-default"
              (click)="confirmModal.hide()"
              ><i class="fa fa-close"></i>{{genericVisuals.return}}</a
            >
            <button
              class="btn btn-success btn-shadowed"
              name="repApproveDemandsSubmitButton"
              (click)="confirmReject()"
              [disabled]="loading || submiting"
            >
              <i class="fa fa-check"></i>{{genericVisuals.submit}}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
